module.exports = __webpack_public_path__ + "img/imagen1.ed215482.png";